import { SearchTypes } from '@/types/common'
import { getToken } from '@/utils/checkLogin'

type History = Record<SearchTypes, string[]>

class SearchHistoryCache {
  CACHE_KEY = '__search_history_cache__'

  defaultHistory: History = {
    [SearchTypes.Influencer]: [],
    [SearchTypes.Live]: [],
    [SearchTypes.Video]: [],
    [SearchTypes.Product]: [],
    [SearchTypes.Shop]: [],
    [SearchTypes.Hashtag]: []
  }

  get token() {
    return getToken()
  }

  resetCache() {
    localStorage.removeItem(this.CACHE_KEY)
  }

  getCache() {
    const str = localStorage.getItem(this.CACHE_KEY)

    if (!str) {
      return this.defaultHistory
    }

    const fn = this.generateCache
    const cache = JSON.parse(str) as ReturnType<typeof fn>

    // 当前用户 token 与缓存时的 token 不一致，视为缓存失效
    // if (cache.token !== this.token) {
    //   this.resetCache()
    //   return this.defaultHistory
    // }

    return cache.history
  }

  setCache(history: History) {
    localStorage.setItem(this.CACHE_KEY, JSON.stringify(this.generateCache(history)))
  }

  generateCache(history: History) {
    return {
      token: this.token,
      history
    }
  }
}

export default new SearchHistoryCache()
